"use client"; // Ensures it runs on the client side

import { useState, useEffect } from "react";

function useIsMobile(breakpoint = 639) {
  const [isMobile, setIsMobile] = useState(false); // Default false for SSR

  useEffect(() => {
    const checkScreenSize = () => {
      const isMobileView = window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
      setIsMobile(isMobileView);
    };

    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);
    window.addEventListener("orientationchange", checkScreenSize); // iOS Fix

    return () => {
      window.removeEventListener("resize", checkScreenSize);
      window.removeEventListener("orientationchange", checkScreenSize);
    };
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
